import GetRequest from "../utilities/api/get-request";

class LinkedProduct {

    /*
    |--------------------------------------------------------------------------
    | Get linked products
    |--------------------------------------------------------------------------
    |
    */

    static async get(filterParameters = {}) {
        const path = '/api/linked-products';

        return await GetRequest(path, filterParameters);
    }

}

export default LinkedProduct;